export default {
  SET_SIGNUP_MODAL_OPEN(state, payload) {
    state.signupModalOpen = payload
  },
}
